export default "__VITE_ASSET__CynIfHXT__"